export enum OrganizationRoles {
  Suspended = 0,
  Viewer = 1,
  User = 3,
  Admin = 5,
  Owner = 7,
}
